function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUkFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 908.614 492.804",
    style: {
      enableBackground: "new 0 0 908.614 492.804"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#001E7F"
    },
    width: 908.246,
    height: 492.804
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "908.246,0 605.496,163.148 537.686,163.148 840.436,0 806.712,0 529.811,149.364 529.811,0  499.475,0 499.475,165.598 499.475,183.827 499.475,195.843 544.873,195.843 612.634,195.843 635.783,195.843 646.407,195.843  908.614,195.843 908.614,163.148 706.975,163.148 908.614,54.575 908.614,48.765 908.614,36.347 908.614,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "378.383,0 378.383,149.364 101.534,0 0,0 302.751,163.148 235.043,163.148 0,36.626  0,54.855 201.217,163.148 0,163.148 0,195.843 261.682,195.843 295.617,195.843 363.216,195.843 408.723,195.843 408.723,183.827  408.723,171.408 408.723,165.598 408.723,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "612.634,293.77 544.873,293.77 499.475,293.77 499.475,305.728 499.475,318.206  499.475,323.957 499.475,492.804 529.811,492.804 529.811,340.307 812.688,492.804 823.361,492.804 846.563,492.804  908.614,492.804 908.614,489.672 605.496,326.349 673.149,326.349 908.614,453.267 908.614,435.038 706.975,326.349  908.614,326.349 908.614,293.77 646.407,293.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "363.216,293.77 295.617,293.77 272.411,293.77 261.682,293.77 0,293.77 0,326.349  201.217,326.349 0,434.811 0,489.438 302.751,326.349 370.404,326.349 61.683,492.804 95.564,492.804 378.383,340.307  378.383,492.804 408.723,492.804 408.723,323.957 408.723,305.728 408.723,293.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7000D"
    },
    points: "302.751,326.349 0,489.438 0,492.804 61.683,492.804 370.404,326.349  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7000D"
    },
    points: "0,36.626 235.043,163.148 302.751,163.148 0,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7000D"
    },
    points: "908.246,0 840.436,0 537.686,163.148 605.496,163.148  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7000D"
    },
    points: "605.496,326.349 908.614,489.672 908.614,453.267 673.149,326.349  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7000D"
    },
    points: "408.723,0 408.723,165.598 408.723,171.408 408.723,183.827 408.723,195.843  363.216,195.843 295.617,195.843 261.682,195.843 0,195.843 0,293.77 261.682,293.77 272.411,293.77 295.617,293.77  363.216,293.77 408.723,293.77 408.723,305.728 408.723,323.957 408.723,492.804 454.072,492.804 499.475,492.804 499.475,323.957  499.475,318.206 499.475,305.728 499.475,293.77 544.873,293.77 612.634,293.77 646.407,293.77 908.614,293.77 908.614,244.836  908.614,195.843 646.407,195.843 635.783,195.843 612.634,195.843 544.873,195.843 499.475,195.843 499.475,183.827  499.475,165.598 499.475,0  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkFlag);
export default __webpack_public_path__ + "static/media/UK_flag.26eccd547847de3f8e178a312533ad2f.svg";
export { ForwardRef as ReactComponent };